import { useRef } from 'react';
import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import ContactSection from '../../sections/ContactSection/ContactSection';
import { GlobalStyle } from '../../global/global';
import {
    Box,
    Text,
    List,
    ListIcon,
    ListItem,
    Image,
    Heading,
    Button,
    Flex,
    Link,
} from '@chakra-ui/react';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import HoverTilesSection from '../../sections/HoverTilesSection/HoverTilesSection';
import TilesSection from '../../sections/TilesSection/TilesSection';
import SectionWithPlusTick from '../../sections/SectionWithPlusTick/SectionWithPlusTick';
import MigrationSection from '../../sections/MigrationSection/MigrationSection';
import { ArrowForwardIcon, CheckIcon } from '@chakra-ui/icons';

interface Props {}
export default function ReturnPage(props: Props) {
    const couriers = [
        {
            title: 'Allegro',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600215&ext=.svg',
        },
        {
            title: 'Amazon',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600216&ext=.svg',
        },
        { title: 'Ebay', image: 'https://www.idosell.com/panel/file-gate.php?id=600217&ext=.svg' },
        { title: 'Empik', image: 'https://www.idosell.com/panel/file-gate.php?id=600218&ext=.svg' },
        { title: 'Ceneo', image: 'https://www.idosell.com/panel/file-gate.php?id=600219&ext=.svg' },
        { title: 'Emag', image: 'https://www.idosell.com/panel/file-gate.php?id=600220&ext=.svg' },
        {
            title: 'Erli',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600221&ext=.svg',
        },
        {
            title: 'Nethansa',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600222&ext=.svg',
        },
        {
            title: 'Morele',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600223&ext=.svg',
        },
        {
            title: 'CDISCOUNT',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600224&ext=.svg',
        },
        {
            title: 'Spartoo',
            image: 'https://www.idosell.com/panel/file-gate.php?id=600225&ext=.svg',
        },
    ];

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Spełniaj oczekiwania klientów. Usprawnij zwroty i reklamacje"
                subTitle="Zadbaj o najlepsze doświadczenie pozakupowe dzięki profesjonalnej obsłudze zwrotów i reklamacji w Twoim sklepie internetowym."
                image={{
                    url: 'https://www.idosell.com/panel/file-gate.php?id=600372&ext=.webp',
                    alt: 'Zdjęcie wyróżniające w hero - strona zwrotów',
                }}
            />

            <div className="homepage containerIdosellPages">
                <Box
                    my={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={{
                        base: 20,
                        md: 24,
                    }}
                >
                    <TilesSection
                        title={
                            'Zyskaj lojalnych klientów.  Daj im swobodę zwrotów na ich warunkach'
                        }
                        subtitle={
                            'Spraw, by zwroty były proste zarówno dla Ciebie, jak i dla Twoich klientów.'
                        }
                        tiles={[
                            {
                                title: 'Oszczędzaj czas',
                                content:
                                    'Automatyzuj procesy związane ze zwrotami i zmniejsz liczbę zapytań od klientów. Dzięki temu oszczędzisz czas i zasoby.',
                            },
                            {
                                title: 'Obniżaj koszty',
                                content:
                                    'Zwroty obsługiwane są wygodnie przez klienta z poziomu jego konta, Dzięki temu zminimalizujesz wydatki związane z obsługą zwrotów.',
                            },
                            {
                                title: 'Zatrzymaj klientów',
                                content:
                                    'Udostępnij wygodne i elastyczne opcje zwrotu, które zbudują lojalność klientów.',
                            },
                        ]}
                    />
                    <Box pt={5}>
                        <SectionWithPlusTick
                            alignItems={'center'}
                            display={'flex'}
                            flexDirection={'column'}
                            background={'#1AAC7A'}
                            type="tick"
                            title="Zwroty, które działają na Twoją korzyść"
                            subtitle="Czy wiesz, że 80% kupujących online nie wróci do e-sklepu po złych doświadczeniach związanych ze zwrotami? Z kreatorem zwrotów w IdoSell zapewnisz szybkie i bezproblemowe zwroty, które zwiększają zaufanie i lojalność kupujących."
                            ctaButton={{
                                label: 'Poznaj kreator zwrotów w IdoSell',
                                href: 'https://www.idosell.com/pl/functions/returns/start/jak-uruchomic-modul-zwrotow/',
                                type: 'link',
                            }}
                            image={{
                                url: 'https://www.idosell.com/panel/file-gate.php?id=600373&ext=.webp',
                                alt: 'Zdjęcie Pani z założonymi rękami',
                            }}
                            tickItem={[
                                {
                                    title: 'Mniej pytań od klientów – klienci mogą samodzielnie inicjować zwroty',
                                },
                                {
                                    title: 'Pełna kontrola – przejrzysty system zarządzania zwrotami w jednym miejscu',
                                },
                                {
                                    title: 'Zgodność z przepisami – bezpieczny i wygodny proces dla Ciebie i klientów',
                                },
                            ]}
                        />
                    </Box>
                    <Flex gap={6} flexWrap={{ base: 'wrap', lg: 'nowrap' }}>
                        <Box
                            bg="#E3E3E3"
                            px={{ base: '20px', lg: '50px' }}
                            py={{ base: '35px', lg: '74px' }}
                            flex="1"
                            minW={{ base: '100%', lg: '50%' }}
                            display={'flex'}
                            flexDirection={'column'}
                        >
                            <Image
                                maxW={'170px'}
                                height={'66px'}
                                mb={'20px'}
                                src="https://www.idosell.com/panel/file-gate.php?id=600390&ext=.svg"
                            />
                            <Heading
                                as={'h3'}
                                fontSize={{ base: '24px', lg: '34px' }}
                                lineHeight={{ base: '36px', lg: '48px' }}
                                mb={'20px'}
                                color="#171717"
                            >
                                Szybkie zwroty w IdoSell Broker
                            </Heading>
                            <Text
                                fontSize={{ base: '15px', lg: '16px' }}
                                mb={'20px'}
                                color="#171717"
                            >
                                Usługa szybkie zwroty z InPost Paczkomaty umożliwia klientom
                                samodzielne wygenerowanie formularza zwrotu oraz kodu nadania
                                paczki, którą mogą wysłać z dowolnego Paczkomatu.  Jako sprzedawca
                                możesz zdecydować, czy pokryjesz koszt zwrotu, czy odliczysz go od
                                reklamacji lub zwrotu. 
                            </Text>
                            <Link
                                href="https://www.idosell.com/pl/broker/"
                                bg="black"
                                color="white"
                                padding={'12px 45px'}
                                textAlign={'center'}
                            >
                                Poznaj Idosell Broker
                            </Link>
                        </Box>
                        <Box
                            bg="#E3E3E3"
                            px={{ base: '20px', lg: '50px' }}
                            py={{ base: '35px', lg: '74px' }}
                            flex="1"
                            minW={{ base: '100%', lg: '50%' }}
                            display={'flex'}
                            flexDirection={'column'}
                        >
                            <Image
                                maxW={'260px'}
                                height={'66px'}
                                mb={'20px'}
                                src="https://www.idosell.com/panel/file-gate.php?id=600391&ext=.svg"
                            />
                            <Heading
                                as={'h3'}
                                fontSize={{ base: '24px', lg: '34px' }}
                                lineHeight={{ base: '36px', lg: '48px' }}
                                mb={'20px'}
                                color="#171717"
                            >
                                Przesyłki zwrotne na umowach własnych
                            </Heading>
                            <Text
                                fontSize={{ base: '15px', lg: '16px' }}
                                mb={{ base: '20px', lg: 'auto' }}
                                color="#171717"
                            >
                                Oferuj przesyłki zwrotne na terenie całej UE. Szybko i wygodnie
                                generuj etykiety zwrotne, które możesz przekazać bezpośrednio po
                                zakupie lub na żądanie.  UPS (przesyłki na terenie UE i krajowe) 
                                Inpost Kurier (tylko przesyłki krajowe)  DHL Express (przesyłki na
                                terenie UE) 
                            </Text>
                            <Link
                                href="https://www.idosell.com/pl/tysiace-gotowych-do-uzycia-funkcji/zwroty-towarow-sprzedanych-w-sklepie-internetowym/zwroty-przesylkami-return-shipment-rs-umozliwiajace-przekazywanie-etykiet-klientom-do-zwrotu-i-reklamacji/zobacz-jak-uruchomic-przesylki-zwrotne-return-shipment-rs/"
                                bg="black"
                                color="white"
                                padding={'12px 45px'}
                                textAlign={'center'}
                            >
                                Dowiedz się więcej
                            </Link>
                        </Box>
                    </Flex>

                    <MigrationSection
                        image={{
                            url: 'https://www.idosell.com/panel/file-gate.php?id=600374&ext=.jpeg',
                        }}
                        boxSide="right"
                        title="Zwroty Smile – proste i wygodne dla Ciebie i Twoich klientów "
                        ctaButton={{
                            title: 'Dowiedz się więcej',
                            href: 'https://www.smile.pl/',
                            variant: 'default',
                        }}
                    >
                        <>
                            <List
                                spacing={'20px'}
                                fontSize={'18px'}
                                lineHeight={'27px'}
                                color={'#171717'}
                                marginBottom={'35px'}
                            >
                                <ListItem display={'flex'}>
                                    <ListIcon as={CheckIcon} color="black" mr={'30px'} mt={'5px'} />
                                    <Box display={'flex'} flexDirection={'column'}>
                                        <Text
                                            fontSize={'21px'}
                                            lineHeight={'31.5px'}
                                            fontWeight={'600'}
                                            color={'#171717'}
                                        >
                                            Mniej zapytań do obsługi klienta
                                        </Text>
                                        <Text
                                            color={''}
                                            fontSize={'16px'}
                                            lineHeight={'1.5'}
                                            fontWeight={'400'}
                                            mb="5px"
                                        >
                                            Dzięki Smile klienci mogą nadać zwrot w kilka sekund –
                                            bez drukowania etykiety i zbędnych formalności.
                                        </Text>
                                    </Box>
                                </ListItem>
                                <ListItem display={'flex'}>
                                    <ListIcon as={CheckIcon} color="black" mr={'30px'} mt={'5px'} />
                                    <Box display={'flex'} flexDirection={'column'}>
                                        <Text
                                            fontSize={'21px'}
                                            lineHeight={'31.5px'}
                                            fontWeight={'600'}
                                            color={'#171717'}
                                        >
                                            Większa lojalność kupujących
                                        </Text>
                                        <Text
                                            color={''}
                                            fontSize={'16px'}
                                            lineHeight={'1.5'}
                                            fontWeight={'400'}
                                            mb="5px"
                                        >
                                            Ułatw swoim klientom proces zwrotu i spraw, by wracali
                                            na kolejne zakupy z uśmiechem.
                                        </Text>
                                    </Box>
                                </ListItem>
                                <ListItem display={'flex'}>
                                    <ListIcon as={CheckIcon} color="black" mr={'30px'} mt={'5px'} />
                                    <Box display={'flex'} flexDirection={'column'}>
                                        <Text
                                            fontSize={'21px'}
                                            lineHeight={'31.5px'}
                                            fontWeight={'600'}
                                            color={'#171717'}
                                        >
                                            Atrakcyjna stawka
                                        </Text>
                                        <Text
                                            color={''}
                                            fontSize={'16px'}
                                            lineHeight={'1.5'}
                                            fontWeight={'400'}
                                            mb="5px"
                                        >
                                            Zwroty w Smile kosztują tylko 13,99 zł.
                                        </Text>
                                    </Box>
                                </ListItem>
                            </List>
                        </>
                    </MigrationSection>
                    <TilesSection
                        title={'Szybkie i proste reklamacje w sklepie internetowym'}
                        subtitle={
                            'Zautomatyzuj proces reklamacji w swoim sklepie. Moduł Reklamacji IdoSell pozwala na szybkie rozpatrywanie zgłoszeń na podstawie zdjęć i opisów usterki przesłanych przez klientów. Zadbaj o to, by każda reklamacja była rozpatrywana szybko i profesjonalnie. Zyskaj zadowolonych i lojalnych klientów.'
                        }
                        tiles={[
                            {
                                title: 'Profesjonalna obsługa klienta',
                                content:
                                    'Na każdym etapie reklamacji klient otrzymuje automatyczne powiadomienia o stanie zgłoszenia, co zwiększa jego zadowolenie i zaufanie do Twojego sklepu.',
                            },
                            {
                                title: 'Efektywne zarządzanie reklamacjami',
                                content:
                                    'Szybko wyszukuj i przeglądaj historię reklamacji, analizuj częstotliwość zgłoszeń i najczęściej reklamowane produkty.',
                            },
                            {
                                title: 'Automatyczne korekty i faktury',
                                content:
                                    'Po zaakceptowaniu reklamacji system automatycznie generuje i wysyła fakturę korygującą, oszczędzając czas i eliminując błędy.',
                            },
                        ]}
                    />
                    <ContactSection />
                </Box>
            </div>
        </ThemeProvider>
    );
}
